<template>
  <v-row v-if="localData" noGutters>
    <v-col cols="auto">
      <v-sheet :height="height" width="350" class="pa-4 overflow-auto">
        <v-textarea
            v-model="localData.data.text"
            outlined dense auto-grow rows="1" hide-details="auto" class="mb-4"
            :readonly="localData.data.templateId!==null"
            :rules="formFieldRules.required"
        >
          <template v-slot:label>
            <div :class="localData.data.templateId==null ? '' : 'pr-8'">Текст сообщения</div>
          </template>
          <template v-slot:prepend-inner>
            <v-icon v-if="localData.data.templateId!==null" class="ml-2 mt-1 mr-2" size="20">mdi-lock</v-icon>
          </template>
          <template v-slot:append>
            <v-btn
                v-if="!$tools.isEmpty(localData.data.text)" icon
                @click="localData.data.text=null;localData.data.templateId=null;localData.data.textTags=[]">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </template>
        </v-textarea>
        <chats-message-tags/>
      </v-sheet>
    </v-col>
    <v-col cols="auto"><v-divider vertical/></v-col>
    <v-col cols="auto">
      <v-sheet :height="height" width="350">
        <chats-message-templates
            :height="height"
            :selectAllowed="true"
            @select="(v)=>{
              localData.data.text = v.text;
              localData.data.templateId = v.id;
              localData.data.textTags = v.textTags;
              preview();
            }"
        />
      </v-sheet>
    </v-col>
    <v-col cols="auto"><v-divider vertical/></v-col>
    <v-col>
      <toolbar-view :title="'Предосмотр сообщений (всего: '+sourceIds.length+')'"/>
      <div v-if="previewState.error">
        <alert>{{previewState.errorMessage}}</alert>
      </div>
      <v-data-table
          v-else
          class="table3"
          :headers="[
            { text: 'Источник', class:'text-no-wrap', sortable:false},
            { text: 'Ф.И.О', class:'text-no-wrap', sortable:false},
            { text: 'Текст', class:'text-wrap', sortable:false},
          ]"
          :items="previewState.data.items"
          :server-items-length="previewState.data.count"
          fixed-header
          :loading="previewState.loading"
          :height="height-48-48"
          :items-per-page="50"
          :options.sync="previewOptions"
          :footer-props="{'items-per-page-options': [50, 100, 500]}"
          dense
      >
        <template v-slot:item="{item}">
          <tr>
            <td class="text-no-wrap">
              <div v-if="sourceType==='visit'">
                <v-btn @click="visitId=item.sourceId" depressed small>Визит</v-btn>
              </div>
              <div v-else>
                {{item.sourceType}} {{item.sourceId}}
              </div>
            </td>
            <td class="text-no-wrap"><user-full-name :user="item.user"/></td>
            <td class="text-wrap">{{item.text}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
    <visit :visitId.sync="visitId"/>
  </v-row>
</template>

<script>
import ChatsMessageTemplates from "@/views/ContactCenter/Messenger/components/ChatsMessageTemplates.vue";
import ChatsMessageTags from "@/views/ContactCenter/Messenger/components/ChatsMessageTags.vue";
import Alert from "@/componentsV2/base/Alert.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import ToolbarView from "@/components/ToolbarView.vue";
import Stater from "@/plugins/stater";
import axios from "axios";
import Api from "@/Api";
import {FormFieldRules} from "@/plugins/formFieldRules";
import Visit from "@/views/Visit/Visit.vue";

export default {
  components: {Visit, ToolbarView, UserFullName, Alert, ChatsMessageTags, ChatsMessageTemplates},
  props: ['data','height','sourceType','sourceIds'],
  data: () => ({
    localData:null,
    formFieldRules: FormFieldRules,
    previewState:new Stater({items:[],count:0}),
    previewOptions:{},
    visitId:null,
  }),
  mounted() {
    this.localData = this.data;
  },
  watch: {
    data() {
      this.localData = this.data;
    },
    localData:{
      handler(){
        this.preview();
        this.$emit('update', this.localData)
      },
      deep: true
    },
    previewOptions(){
      this.preview();
    }
  },
  methods:{
    preview(){
      if(this.$tools.isEmpty(this.localData.data.text))
        return;
      this.previewState.stateLoading();
      this.$tools.debounce(() => {
        axios.post(Api.host + '/messenger/distribute/preview/', {
          page: this.previewOptions.page,
          onPage: this.previewOptions.itemsPerPage,
          sourceType: this.sourceType,
          sourceIds: this.sourceIds,
          text: this.localData.data.text,
          textTags: this.$tools.isEmpty(this.localData.data.textTags) ? [] : this.localData.data.textTags,
        }).then((r) => {
          this.previewState.data = r.data;
          this.previewState.stateSuccess()
        }).catch(() => {
          this.previewState.stateError()
        });
      }, 1000);
    },
  }
}
</script>